import { render } from "./MilestoneCard.vue?vue&type=template&id=6d1a8fb4"
import script from "./MilestoneCard.vue?vue&type=script&lang=js"
export * from "./MilestoneCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__